<template>
  <simulation-results
      :simulationResultConfig="simulationResultConfig">
    <template #user-panel-credit-parameters-extension>
      <fp-input
          dense
          :suffix="$env.currentCurrency()"
          prepend-icon="mdi-cash-fast"
          type="number"
          int
          required
          v-model="store.userInput.loanAmount"></fp-input>
      <fp-input
          dense
          :label="I18NGetter().useCashSimulationResultsAndFormStep1.LOAN_PERIOD"
          :suffix="I18NGetter().useCashSimulationResultsAndFormStep1.MONTHS"
          prepend-icon="mdi-clock-outline"
          v-model="store.userInput.loanPeriod"
          int
          required
          type="number"/>
      <v-flex>
        <span class="font-weight-medium">{{ I18NGetter().useCashSimulationResultsAndFormStep1.LOAN_TYPES }}</span>
        <v-layout wrap>
          <v-flex xs12>
            <fp-checkbox
                v-model="store.userInput.loanTypes.cash"
                :label="I18NGetter().useCashSimulationResultsAndFormStep1.CASH"/>
          </v-flex>
          <v-flex xs12 wrap>
            <fp-checkbox
                v-model="store.userInput.loanTypes.consolidation"
                :label="I18NGetter().useCashSimulationResultsAndFormStep1.CONSOLIDATION"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </template>
  </simulation-results>
</template>
<script lang="ts">
import {ProductType} from '@/commons/enums/ProductType';
import {SimulationResultConfig} from '@/components/calculator/results/SimulationResultConfig';
import {OfferDataTableElementKey} from '@/components/calculator/results/offers/OfferTableElement';
import {numeralFormat} from '@/filters/StringFilters';
import {Offer} from '@/models/simulation/Simulation';
import {defineComponent, getCurrentInstance, onMounted, Ref, ref} from 'vue';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {UserInputPanelElementEnum} from '@/components/calculator/results/userInputPanel/UserInputPanelElementEnum';
import SimulationResults from '@/components/calculator/results/SimulationResults.vue';
import {CashTableElements} from '@/components/calculator/results/tableElements/CashTableElements';
import {useDealForm} from '@/components/calculator/form/useSimulationForm';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';

export default defineComponent({
  components: {SimulationResults,},
  setup() {
    const instance = getCurrentInstance();
    const simulationResultConfig: Ref<SimulationResultConfig> = ref({
      fullscreen: !!instance?.proxy.$vuetify.breakpoint.mdAndDown,
      userInputPanels: [] as UserInputPanelElementEnum[],
    });
    const store = useSimulationStore();
    const simulationId = instance?.proxy.$route.params.simulationId;
    store.init(ProductType.CASH, simulationId);

    return {
      simulationResultConfig,
      store,
      I18NGetter,
    };
  },
});
</script>
<style scoped lang="scss">
</style>
